import {
	Button,
	FlexAlign,
	FlexGap,
	StackHorizontal,
	StackVertical,
	Tooltip,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { ThumbnailSize } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/ThumbnailTypes';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { MailPartTypeEnum } from '../../../Mailboxes/Components/Thumbnails/Types/ThumbnailTypes';
import { MapMailItemThumbnails } from '../../../Mailboxes/Components/Thumbnails/MapMailItemThumbnails';

function MailItemContents() {
	const { t } = useTranslation();
	const { mailItemData } = useMailbox();

	return (
		<div className='mail-item-contents'>
			{mailItemData?.files &&
				mailItemData?.files?.map((file, index: number) => {
					if (file.mailPart === MailPartTypeEnum['Mail-Contents']) {
						return (
							<StackVertical>
								<StackHorizontal align={FlexAlign.Center} gap={FlexGap.ExtraSmall} extraClass='mb-sm'>
									<h6 className='pageantry-sub-heading text-left mb-0'>
										{t('mailItem.labels.contents')}{' '}
										{mailItemData?.totalPages > 0
											? `- ${mailItemData?.totalPages.toString()} ${mailItemData?.totalPages === 1 ? 'Page' : 'Pages'}`
											: ''}
									</h6>

									{!file.topupRequired && !file.isLocked && file.userFile && (
										<Tooltip content={t('actions.download')}>
											<Button
												title={t('actions.download')}
												icon={faDownload}
												iconOnly
												squared
												actionLink={{
													title: t('actions.download'),
													target: '_blank',
													url: file.userFile.linkToFile,
													download: file.userFile.fileName,
												}}
											/>
										</Tooltip>
									)}
								</StackHorizontal>

								<object
									data={file.userFile?.linkToFile}
									type='application/pdf'
									className='pdf-viewer'
									aria-label='File Preview'
								/>
							</StackVertical>
						);
					}

					return (
						<StackVertical>
							<StackHorizontal align={FlexAlign.Center} gap={FlexGap.ExtraSmall} extraClass='mb-sm'>
								<h6 className='pageantry-sub-heading text-left mb-0'>
									{t('mailItem.labels.envelope')}
								</h6>

								{!file.topupRequired && !file.isLocked && file.userFile && (
									<Tooltip content={t('actions.download')}>
										<Button
											title={t('actions.download')}
											icon={faDownload}
											iconOnly
											squared
											actionLink={{
												title: t('actions.download'),
												target: '_blank',
												url: file.userFile?.linkToFile,
												download: file.userFile?.fileName,
											}}
										/>
									</Tooltip>
								)}
							</StackHorizontal>

							<MapMailItemThumbnails
								mailType={MailPartTypeEnum['Mail-Envelopes']}
								files={mailItemData.files}
								size={ThumbnailSize.Aspect}
							/>
						</StackVertical>
					);
				})}
		</div>
	);
}

export { MailItemContents };
